import {Button, Input} from 'antd';
import {useState} from 'react';
import {setUserPassword} from '../../api/Api';

export const PasswordInput = ({user, onApiFail}) => {
    const msgTimeout = 4000;
    const messages = {
        none: <div />,
        success: <div style={{color: 'green'}}>Password Changed</div>,
        fail: <div style={{color: 'red'}}>Password Change Failed</div>
    }

    const [pwMsg, setPwMsg] = useState(messages.none);
    const [password, setPassword] = useState("");
    const onPasswordChange = (e) => {
        setPassword(e.target.value);
    }
    const onSubmit = () => {
        setUserPassword(user.id, password).then(result => {
            setPwMsg(messages.success);
            setTimeout(() => {
                setPwMsg(messages.none);
            }, msgTimeout)
        }).catch(e => {
            if (e.status === 401) {
                onApiFail();
            } else {
                setPwMsg(messages.fail);
                setTimeout(() => {
                    setPwMsg(messages.none);
                }, msgTimeout);
            }
        })
    }

    return <div>
        <div style={{display: "grid", gridTemplateColumns: "100px auto auto"}} >
            <div>Set Password:</div>
            <div><Input.Password onChange={onPasswordChange}/></div>
            <div><Button onClick={onSubmit}>Submit</Button></div>
        </div>
        <div>{pwMsg}</div>
    </div>
}